import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

export const useProjectUuidParam = () => {
  const projectUuid = useParams<{ projectUuid: string }>().projectUuid;
  return useMemo(() => projectUuid, [projectUuid]);
};

export const useProjectUuidParamModerator = () => {
  const params = useParams<{ event_uuid: string }>();
  return useMemo(() => params?.event_uuid, [params?.event_uuid]);
};
